import { DetailI } from "./dataConfigTypes";

export const getCategoryConfig = (dataConfig: DetailI, category: string) => {
  if (dataConfig.name !== "default") {
    const categoryConfig = dataConfig.categories.find(
      c => c.name === category || c.nameHr == category
    );

    if (categoryConfig) {
      return categoryConfig;
    }
  }

  return dataConfig.categories[0];
};



// WEBPACK FOOTER //
// ./src/dataConfig/categoryConfig.ts